(function(angular){
    'use strict';

    angular.module('aprima-provider-api').factory('CustomDiagnosisRepository', [
        '$q',
        'AprimaAnalytics', 
        'AprimaRestangular', 
        CustomDiagnosisRepository
    ]);

    function CustomDiagnosisRepository(
        $q, 
        AprimaAnalytics, 
        AprimaRestangular
    ) {
        var routePrefix = 'custom-diagnosis';

        var service = {
            getdiagnoses: _.partial(getdiagnoses, null),
            abortable: abortable,
        };
        
        return service;

        function abortable(promisesToAbort) {
            return {
                getdiagnoses: _.partial(getdiagnoses, promisesToAbort)
            };
        }
        

        function getdiagnoses(promisesToAbort,paramsObj){
            var result=get(promisesToAbort,'getdiagnoses',paramsObj,customGet);
            return result;
        }


       function get(promisesToAbort, route, params, getFn) {
            var restElement = AprimaRestangular.get().all(routePrefix).all(route);
            if(promisesToAbort) {
                restElement = restElement.abortable(promisesToAbort);
            }

            return getFn(restElement, params).then(function(data) {
                if(_.isNil(data)) {
                    return $q.reject('IMO ' + api + ' request failed for params: ' + JSON.stringify(params));
                }

                return data;
            });
        }

        function customGet(element, params) {
            return element.customGET('', params);
        }

    }
})(window.angular);